import { render } from "./IaSection.vue?vue&type=template&id=6649ede5&scoped=true"
import script from "./IaSection.vue?vue&type=script&lang=js"
export * from "./IaSection.vue?vue&type=script&lang=js"

import "./IaSection.vue?vue&type=style&index=0&id=6649ede5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6649ede5"]])

export default __exports__